// extracted by mini-css-extract-plugin
module.exports = {"switchShips":"SwitchShips_switchShips__PDNXZ","wrap":"SwitchShips_wrap__r_CXq","button":"SwitchShips_button__qvA3P","active":"SwitchShips_active__1fLQl"};